import { useEffect, useState } from 'react'
import { reportFolioServices } from '../../main/constants/states'
import { format } from 'date-fns'
import { Constants } from '../../../../../../../utils/constants'
import { useTranslation } from 'react-i18next'
import { Roles, Status, Status as StatusEnum, Types } from '../../../../../../../utils/enums'
import { useLocation, useNavigate } from 'react-router-dom'
import { useReportFoliosDetailContext } from './useReportFoliosContext'
import { useMenuList } from '../components/menuOptions/contants'
import { getLocalStorage, LocaleNameType } from '../../../../../../../utils/crud/crypt'
import { DataDetail, Snackbar } from '../types'
import { detailData } from '../format'
import { ConfirmModal } from '../../main/components'
import { FolioType } from '../../../utils/enums/folioType'
import { reportFolioDetailMenuType } from '../enums'
import { Priority } from '../../../../../../../utils/enums/priority'
import { FolioTypeEndPoint } from '../../../utils/enums/endpointFolioType'

const useGetData = ({
  id,
  options
}: {
  id?: string,
  options?: {
    id: number;
    label: string;
    value: string;
    check: boolean;
  }[]
}) => {
  const menuList = useMenuList()
  const state = getLocalStorage(LocaleNameType.STATE)
  const userId = state?.id
  const roleId = state?.role
  let location = useLocation();
  const { setCreatorUser, setStatusAttention, setUserAssigned, setUserTracking, selectOption, setTypeFolio } = useReportFoliosDetailContext()
  const { t } = useTranslation()
  const navigation = useNavigate()
  const [snackbarModal, setSnackbarModal] = useState<Snackbar>({ message: '', type: Types.ERROR, open: false, openSuuccess: false, })
  const [data, setData] = useState<DataDetail>({})
  const [loading, setLoading] = useState(false)
  const [historialError, setHistorialError] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const [confirmModal, setConfirmModal] = useState({
    open: false,
    title: '',
    description: '',
    onConfirm: async () => { },
    onClose: () => { },
    //onCancel: () => { }
  })
  const closeSnackbarModal = () => {
    setSnackbarModal(prev => ({ ...prev, openSuuccess: false, cancel: undefined, next: undefined, description: undefined }))
  }

  const getData = async () => {
    if (!!id) {
      setLoading(true)
      const item = await reportFolioServices.reportFolioById({ id: id ? parseInt(id) : 1 })
      const statusAttencionId = item.statusAttentionId
      const isUserAssigned = item.userAttendingId == userId
      const isCreaterUser = item.createdByUser?.id == userId
      const isAdmin = roleId == Roles.ADMIN
      const option = Number(location?.state?.option) - 3
      const state: { isManagerOfDeparment: boolean, role: number, id: string | number } = getLocalStorage(LocaleNameType.STATE);
      const isManagerOfDepartment = state?.isManagerOfDeparment;
      const isPriorityHigh = item.priority?.id === Priority.HIGH || item.priority?.id === Priority.URGENT;
      const { newData, userAssigned, userTracking } = detailData({ oldData: data, responseReportFoliosById: item, t })

      await checkFolioAccess(item, userAssigned)
      const isSomeAssignedUser = userAssigned.some(item => item.id == userId)
      setUserTracking(userTracking)
      setTypeFolio(item.type == "preventive" ? FolioType.PREVENTIVE : FolioType.CORRECTIVE)
      const message = {
        openSuuccess: true,
        message: 'Advertencia',
        cancel: () => {
          navigation('/dashboard/report-folio/dashboard')
          closeSnackbarModal()
        },
        next: () => {
          closeSnackbarModal()
        }
      }
      if (!!option && option !== Number(reportFolioDetailMenuType.REASIGN_USER) && (StatusEnum.WAITING != statusAttencionId && !isUserAssigned) /* && item.type != "preventive" */) {
        setSnackbarModal(prev => ({
          ...prev,
          ...message,
          description: `El folio ya está siendo atendido por: ${userAssigned?.find(itemU => itemU.value == item.userAttendingId)?.label ?? ''}, no es posible realizar la ${t(`reportFolio.reassignStatus.${option}`)} del folio ¿Deseas continuar?.`,
        }))
      }
      setCreatorUser({
        user: `${item.createdByUser?.firstName} ${item.createdByUser?.lastName}`,
        date: item?.createTime && format(new Date(item?.createTime), Constants.dateFormatGeneral3),
        id: item?.createdByUser?.id,
      })
      setStatusAttention({
        statusAttentionId: item?.statusAttentionId,
        userAttendingId: item?.userAttendingId
      })
      setUserAssigned(userAssigned)
      setData(prev => ({ ...prev, ...newData }))
      setLoading(false)
      if (location?.state?.option && option !== Number(reportFolioDetailMenuType.REASIGN_USER) && [StatusEnum.AWAIT_SOLUTION, StatusEnum.APPROVED].includes(item?.status?.id)) {
        if (option == 2 && (((!!isAdmin || !!isCreaterUser || !!isUserAssigned) && StatusEnum.WAITING == statusAttencionId) || (StatusEnum.WAITING != statusAttencionId && !!isUserAssigned))) {
          selectOption(menuList[1])
        } else if (!isSomeAssignedUser && (!statusAttencionId || StatusEnum.WAITING == statusAttencionId)) {
          selectOption(menuList.find(item => item.value == option) ?? null)
        }
      }

      if (
        location?.state?.option &&
        (
          (
            (!!isAdmin || !!isManagerOfDepartment || !!isUserAssigned || item.canReassign) &&
            ![Status.APPROVED, Status.REJECTED, Status.CANCEL, Status.EXPIRED, Status.NOT_FINISHED].includes(item?.status?.id) &&
            !item.existAnyQuote &&
            !isPriorityHigh &&
            item.type != FolioTypeEndPoint.PREVENTIVE
          ) || (item.reportFolioUserAssign.length == 0 && item.canReassign)
        )
         /* && !hasPendingSolution */) {
        selectOption(menuList.find(item => item.value == option) ?? null)
      }

    }

  }

  const getComments = () => {
    reportFolioServices.reportFolioById({ id: id ? parseInt(id) : 1 }).then((item) => {
      setData((prev) => ({
        ...prev,
        ...(!!prev.left && {
          left: {
            ...prev.left,
            comments:
              item?.reportFolioComments
                ?.slice()
                ?.sort((a, b) =>
                  new Date(b.createTime).getTime() - new Date(a.createTime).getTime()
                )
                ?.map((itemComments) => ({
                  description: itemComments?.comment,
                  user: `${itemComments?.createdByUser?.firstName} ${itemComments?.createdByUser?.lastName}`,
                  date:
                    itemComments?.createTime &&
                    format(new Date(itemComments?.createTime), Constants.dateFormatGeneral2),
                })) ?? []
          },
        }),
      }))
    })
  }

  const getHistorial = async (isCommentInstruction?: boolean, showSolution?: boolean) => {
    if (!data.left?.type) {
      setIsLoading(true);
      return;
    }
    setIsLoading(true);
    try {
      const response = data.left.type === "preventive"
        ? await reportFolioServices.getHistorialFolioPreventive(id, isCommentInstruction, showSolution)
        : await reportFolioServices.getHistorialFolio(id, isCommentInstruction, showSolution);

      if (response.errors) {
        setData((prev) => ({
          ...prev,
          historial: {
            hasError: true,
            items: [],
          },
        }));
      } else {
        setData((prev) => ({
          ...prev,
          historial: {
            hasError: false,
            items: response,
          },
        }));
      }
    } catch (error) {
      console.error("Error en getHistorial:", error);
      setData((prev) => ({
        ...prev,
        historial: {
          hasError: true,
          items: [],
        },
      }));
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData()
    //eslint-disable-next-line
  }, [id])

  useEffect(() => {
    if (data.left?.type !== undefined) {
      const safeOptions = options ?? [];

      const commentChecked = safeOptions.find(o => o.value === 'COMMENT')?.check;
      const solutionChecked = safeOptions.find(o => o.value === 'SOLUTION')?.check;

      getHistorial(commentChecked, solutionChecked);
    }
  }, [data.left?.type]);

  const closeConfirmModal = () => {
    setConfirmModal(prev => ({ ...prev, open: false }))
  }

  const checkFolioAccess = async (item: any, userAssigned: any[]) => {
    const isUserAssigned = item.userAttendingId === userId
    const isCreaterUser = item.createdByUser?.id === userId
    const isAdmin = roleId === Roles.ADMIN
    const isAssignedProvider = item.reportFolioUserAssign?.some((user: any) => user.id === userId)
    const departmentManager = item.department.userManagers.some(manager => manager.id === userId)

    if ([StatusEnum.FINISHED, StatusEnum.REJECTED].includes(item.statusId)) {
      return true
    }


    if (item.statusAttentionId === StatusEnum.STARTED && !isUserAssigned && (item.status.id == StatusEnum.WAITING || item.status.id == StatusEnum.AWAIT_SOLUTION) /* && item.type !== "preventive" */) {
      const response = await reportFolioServices.someOneIsGivingASolution(id)
      if (response.attending) {
        setConfirmModal({
          open: true,
          title: 'Aviso',
          description: `Este folio está siendo atendido por el proveedor ${response.fullname}.`,
          onConfirm: async () => {
            closeConfirmModal()
          },
          onClose: () => {
            closeConfirmModal()
          }
        })
      }
    }
    return true
  }

  return { data, loading, snackbarModal, setSnackbarModal, getData, getComments, getHistorial, isLoading, confirmModal, closeConfirmModal }
}

export { useGetData }